// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2wP6M","alert":"SettungsInbox_alert__2VYNd"};